import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "map-figure" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["media", "srcset"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "map-figure__layer" }
const _hoisted_6 = {
  class: "map-figure__svg",
  width: "1920",
  height: "700",
  viewBox: "0 0 1920 700",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_7 = {
  key: 1,
  class: "map-detail"
}
const _hoisted_8 = { class: "map-detail__map" }

import { throttle } from 'lodash';
import { ref, computed, onBeforeUnmount, onMounted, watch } from 'vue';
import NortheastDetail from '@/components/map/map-detail/NortheastDetail.vue';
import SouthwestDetail from '@/components/map/map-detail/SouthwestDetail.vue';
import SoutheastDetail from '@/components/map/map-detail/SoutheastDetail.vue';
import Northeast from './map-sections/Northeast.vue';
import Southwest from './map-sections/Southwest.vue';
import Southeast from './map-sections/Southeast.vue';
import { landPlotStore } from '@/store/modules/LandPLot';
import { cardSettingsStore } from '@/store/modules/CardSettings';
import { getURL } from '@/helpers/routeHelpers';
import { MOBILE_TOP } from '@/constants/sizes';


export default /*@__PURE__*/_defineComponent({
  __name: 'MapFigure',
  setup(__props) {

const mapScroll = {
    touchStartPosition: 0,
    touchMovePosition: 0,
    deltaX: 0,
    animationFrameId: 0,
    isScrolling: false,
    startTranslateX: 0,
};

let resizeObserver: ResizeObserver | null = null;

const mapScrollWrapper = ref<HTMLElement | null>(null);
const mapScrollItem = ref<HTMLElement | null>(null);

const zone = computed(() => {
    return landPlotStore.CURRENT_SECTION_ZONE;
});

function createScrollDataObject() {
    let Xmax = 0;

    if (mapScrollWrapper.value && mapScrollItem.value) {
        Xmax =
            mapScrollWrapper.value.getBoundingClientRect().width -
            mapScrollItem.value.getBoundingClientRect().width;

        cardSettingsStore.SET_DATA({
            mapWrapper: mapScrollWrapper.value,
            mapWrapperItem: mapScrollItem.value,
            z: mapScrollWrapper
                ? mapScrollWrapper.value.getBoundingClientRect().width
                : 0,
            vw: mapScrollItem
                ? mapScrollItem.value.getBoundingClientRect().width
                : 0,
            Xmax: Xmax,
        });
    }
}

async function onClick(data: string) {
    cardSettingsStore.SET_STATUS_CARD_PLOT_ZONE_SHOW(false);
    landPlotStore.SET_CURRENT_SECTION_ZONE(data);
}

async function showLandPlotCardZone(data: {
    value: string;
    e: MouseEvent;
}) {
    const { value, e } = data;

    if (e.target instanceof Element) {
        const target = e.currentTarget;
        //@ts-ignore
        const sectionTitle = target.querySelector('.section-title');
        const mapRect = cardSettingsStore.MAP_DOM_RECT;

        if (sectionTitle) {
            sectionTitle.style.opacity = '0';
        }

        const dataRect = e.target.getBoundingClientRect();
        const reselutDataRect = {
            bottom: dataRect.bottom,
            height: dataRect.height,
            left: dataRect.left,
            right: dataRect.right,
            top: dataRect.top,
            topMap: mapRect.top,
            width: dataRect.width,
            x: dataRect.x,
            y: dataRect.y - mapRect.y,
        };

        cardSettingsStore.SET_POSITION_CARD_PLOT_ZONE(reselutDataRect);

        cardSettingsStore.SET_STATUS_CARD_PLOT_ZONE_SHOW(true);
        await landPlotStore.CREATE_LAND_PLOT_CARD_ZONE(value);
    }
}

function mouseOutHandler(e: MouseEvent) {
    if (e.target instanceof Element) {
        const target = e.currentTarget;
        cardSettingsStore.SET_STATUS_CARD_PLOT_ZONE_SHOW(false);
    }
}

function throttleOver(data: { value: string; e: MouseEvent }) {
    if (window.innerWidth >= 1200){
    throttle(showLandPlotCardZone, 1000)(data);
}
}

function throttleOut(e: any) {
    throttle(mouseOutHandler, 1000)(e);
}

function resetFilter() {
    landPlotStore.ZONE_RESET_LAND_PLOT_FILTERS();
    landPlotStore.SET_FILTER_STATUS(false);
}

function lerp(start: number, end: number, interpolation: number) {
    return (1 - interpolation) * start + interpolation * end;
}

function render() {
    let tempDeltaX = lerp(
        mapScroll.deltaX,
        mapScroll.touchMovePosition,
        0.08,
    );
    tempDeltaX = Math.floor(tempDeltaX * 100) / 100;

    if (mapScroll.deltaX === tempDeltaX) {
        if (!mapScroll.isScrolling) {
            cancelAnimationFrame(mapScroll.animationFrameId);
        }
    } else {
        mapScroll.deltaX = tempDeltaX;

        cardSettingsStore.SET_TRANSLATE_X(
            mapScroll.startTranslateX +
            (mapScroll.deltaX - mapScroll.touchStartPosition),
        );

        mapScroll.animationFrameId = requestAnimationFrame(render);
    }
}

function onTouchStart(e: TouchEvent) {
    cancelAnimationFrame(mapScroll.animationFrameId);

    mapScroll.isScrolling = false;
    mapScroll.touchStartPosition = mapScroll.touchMovePosition =
        e.touches[0].clientX;
    mapScroll.startTranslateX = cardSettingsStore.TRANSLATE_X;
}

function onTouchMove(e: TouchEvent) {
    mapScroll.touchMovePosition = e.touches[0].clientX;

    if (!mapScroll.isScrolling) {
        render();

        mapScroll.isScrolling = true;
    }
}

function onTouchEnd() {
    mapScroll.isScrolling = false;
}

function setDefaultPosition() {
    if (!zone.value && cardSettingsStore.MAP_DOM_RECT.width < MOBILE_TOP) {
        cardSettingsStore.SET_TRANSLATE_X(0);
    } else {
        cardSettingsStore.SET_TRANSLATE_X(
            cardSettingsStore.TRANSLATE_CENTER,
        );
    }
}

function onWindowResize() {
    cardSettingsStore.SET_TRANSLATE_X(
        cardSettingsStore.CURRENT_TRANSLATE_X,
    );
}

watch(zone, setDefaultPosition);

onMounted(() => {
    setTimeout(() => {
        createScrollDataObject();

        setDefaultPosition();
    }, 0);

    resizeObserver = new ResizeObserver(createScrollDataObject);

    if (mapScrollWrapper.value && mapScrollItem.value) {
        resizeObserver.observe(mapScrollItem.value);
        resizeObserver.observe(mapScrollWrapper.value);
    }

    window.addEventListener('resize', onWindowResize);
});

onBeforeUnmount(() => {
    resizeObserver?.disconnect();

    window.removeEventListener('resize', onWindowResize);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "mapScrollWrapper",
      ref: mapScrollWrapper,
      id: "full-map-scroll-wrapper",
      class: "map-scroll-wrapper",
      onTouchstart: onTouchStart,
      onTouchmove: onTouchMove,
      onTouchend: onTouchEnd
    }, [
      _createElementVNode("div", {
        id: "full-map-scroll-wrapper-item",
        ref_key: "mapScrollItem",
        ref: mapScrollItem,
        class: "map-figure map-scroll-wrapper__map",
        style: _normalizeStyle({
                    transform: `translateX(${_unref(cardSettingsStore).CURRENT_TRANSLATE_X}px)`,
                })
      }, [
        (!zone.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("picture", null, [
                _createElementVNode("source", {
                  media: `(max-width: ${_unref(MOBILE_TOP)}px)`,
                  srcset: `${_unref(getURL)()}/${require('@/assets/img/Map/newcliptestmap.jpg')}`
                }, null, 8, _hoisted_3),
                _createElementVNode("img", {
                  class: "map-figure__bg",
                  src: `${_unref(getURL)()}/${require('@/assets/img/Map/newcliptestmap.jpg')}`
                }, null, 8, _hoisted_4)
              ]),
              _createElementVNode("figure", _hoisted_5, [
                (_openBlock(), _createElementBlock("svg", _hoisted_6, [
                  _createVNode(Northeast, {
                    onClick: onClick,
                    onMouseover: throttleOver,
                    onMouseout: throttleOut
                  }),
                  _createVNode(Southwest, {
                    onClick: onClick,
                    onMouseover: throttleOver,
                    onMouseout: throttleOut
                  }),
                  _createVNode(Southeast, {
                    onClick: onClick,
                    onMouseover: throttleOver,
                    onMouseout: throttleOut
                  })
                ]))
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (zone.value === 'northeast')
                  ? (_openBlock(), _createBlock(NortheastDetail, { key: 0 }))
                  : _createCommentVNode("", true),
                (zone.value === 'southwest')
                  ? (_openBlock(), _createBlock(SouthwestDetail, { key: 1 }))
                  : _createCommentVNode("", true),
                (zone.value === 'southeast')
                  ? (_openBlock(), _createBlock(SoutheastDetail, { key: 2 }))
                  : _createCommentVNode("", true)
              ])
            ]))
      ], 4)
    ], 544)
  ]))
}
}

})